import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import CONFIG from '../../app-configs'
import { ApiAuthStrategies } from '../shared/ApiAuthStrategies'

export const adminCellOwnerAgreementsApi = createApi({
  reducerPath: 'adminCellOwnerAgreementsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${CONFIG.PROXIMA_BACK_END_V2_BASE_API_URL}/asset-holdings/asset-holders/cell-owner-agreements`,
    prepareHeaders: (headers: Headers, { getState }) => {
      const authToken = ApiAuthStrategies.getBearerTokenHeader()
      headers.set('authorization', authToken)
      return headers
    }
  }),
  endpoints: (builder) => ({
    getAdminPdfUrl: builder.query({
      query: ({ cellOwnerAgreementId }) => ({
        url: `${cellOwnerAgreementId}/pdf-url`,
        params: { }
      })
    })
  })
})

export const useCoaGetPdfUrlLazyQuery = adminCellOwnerAgreementsApi.endpoints.getAdminPdfUrl.useLazyQuery
